import * as ChatOrigins from './constants';

export const underwritingMappings = (url: string) => {
  if (/\/underwriting/.test(url)) {
    return [
      [/\/underwriting\/error/, ChatOrigins.UNDERWRITING_ERROR],
      [/\/underwriting\/backtosearch/, ChatOrigins.UNDERWRITING_BACKTOSEARCH],
      [/\/underwriting\/personal/, ChatOrigins.UNDERWRITING_PERSONAL],
      [/\/underwriting\/identity-verification/, ChatOrigins.UNDERWRITING_IDENTITY_VERIFICATION],
      [/\/underwriting\/license/, ChatOrigins.UNDERWRITING_LICENSE],
      [/\/underwriting\/income/, ChatOrigins.UNDERWRITING_INCOME],
      [/\/underwriting\/residency/, ChatOrigins.UNDERWRITING_RESIDENCY],
      [/\/underwriting\/trade/, ChatOrigins.UNDERWRITING_TRADE],
      [/\/underwriting\/(.+)\/personal/, ChatOrigins.UNDERWRITING_ORDER_PERSONAL],
      [
        /\/underwriting\/(.+)\/identity-verification/,
        ChatOrigins.UNDERWRITING_ORDER_IDENTITY_VERIFICATION,
      ],
      [/\/underwriting\/(.+)\/license/, ChatOrigins.UNDERWRITING_ORDER_LICENSE],
      [/\/underwriting\/(.+)\/income/, ChatOrigins.UNDERWRITING_ORDER_INCOME],
      [/\/underwriting\/(.+)\/residency/, ChatOrigins.UNDERWRITING_ORDER_RESIDENCY],
      [/\/underwriting\/(.+)\/trade/, ChatOrigins.UNDERWRITING_ORDER_TRADE],
    ];
  }
  return [];
};
